export default __webpack_public_path__ + "0d9d54c94dc5c0755d8a8d8c046dbbde.jpg";